/* eslint-disable react-hooks/exhaustive-deps */
import React, { createContext, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import TngDisbursementSettingPanelComponent from "./tngDisbursementSettingPanel.component";
import {
  getCreditOverview,
  resetCreditOverview,
} from "modules/campaign/consumer-engagement/redux";

export const TngDisbursementContext = createContext();

export default function TngDisbursementSettingPanelContainer({
  disbursementInfo,
}) {
  const dispatch = useDispatch();

  const overview = useSelector((state) => state.disbursement.overview.data);
  const isError = useSelector((state) => state.disbursement.overview.list);

  useEffect(() => {
    handleOverviewDataLoad();
    return () => {
      dispatch(resetCreditOverview());
    };
  }, []);

  const handleOverviewDataLoad = () => {
    dispatch(getCreditOverview());
  };

  return (
    <TngDisbursementContext.Provider
      value={{
        handleOverviewDataLoad,
        overview,
        isError,
        disbursementInfo,
      }}
    >
      <TngDisbursementSettingPanelComponent />
    </TngDisbursementContext.Provider>
  );
}
